import { Star, Quote } from "lucide-react";

export default function TestimonialCard({ item, index = 0 }) {
  return (
    <article
      data-testid={`testimonial-${index}`}
      className="relative bg-[#fffdf9] rounded-2xl p-8 border border-[#e5e0d8] flex flex-col gap-5 h-full"
    >
      <Quote className="w-8 h-8 text-[#c85a3c]/70" strokeWidth={2.2} />
      <p className="text-[15px] md:text-base leading-relaxed text-[#2c2a29] font-medium flex-1">
        “{item.quote}”
      </p>
      <div className="flex items-center gap-1 text-[#849982]">
        {Array.from({ length: item.rating }).map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-current" strokeWidth={0} />
        ))}
      </div>
      <div className="flex items-center justify-between pt-4 border-t border-[#e5e0d8]">
        <div>
          <div className="font-display font-bold text-[#2c2a29]">
            {item.name}
          </div>
          <div className="text-xs text-[#5c5855]">{item.location}</div>
        </div>
        <span className="text-[10px] tracking-[0.2em] uppercase font-bold text-[#8b5d4e] bg-[#e5e0d8] px-3 py-1.5 rounded-full">
          {item.service}
        </span>
      </div>
    </article>
  );
}
